import { makeSubstitutionModule } from "./FormulaSubstitutionShared";

export const TYPE = "FormulaSubstitutionGeometryTask";

const TEMPLATES = [
  {
    prompt: "Oblicz pole prostokąta ze wzoru, podstawiając dane długości boków.",
    formulaLatex: "P=a\\cdot b",
    valuesLatex: "a=8\\ \text{cm},\\ b=5\\ \text{cm}",
    answerSymbol: "P",
    answerLabelLatex: "P",
    answer: 40,
    unitLatex: "cm^2",
    substitutionLatex: "P=8\\cdot 5",
    resultLatex: "40",
  },
  {
    prompt: "Oblicz obwód prostokąta ze wzoru, podstawiając dane długości boków.",
    formulaLatex: "O=2a+2b",
    valuesLatex: "a=7\\ \text{cm},\\ b=3\\ \text{cm}",
    answerSymbol: "O",
    answerLabelLatex: "O",
    answer: 20,
    unitLatex: "cm",
    substitutionLatex: "O=2\\cdot 7+2\\cdot 3",
    resultLatex: "20",
  },
  {
    prompt: "Oblicz objętość prostopadłościanu ze wzoru, podstawiając dane długości krawędzi.",
    formulaLatex: "V=a\\cdot b\\cdot c",
    valuesLatex: "a=4\\ \text{cm},\\ b=3\\ \text{cm},\\ c=6\\ \text{cm}",
    answerSymbol: "V",
    answerLabelLatex: "V",
    answer: 72,
    unitLatex: "cm^3",
    substitutionLatex: "V=4\\cdot 3\\cdot 6",
    resultLatex: "72",
  },
];

const moduleApi = makeSubstitutionModule(TYPE, TEMPLATES);

export const generateTask = moduleApi.generateTask;
export const renderTask = moduleApi.renderTask;
export const renderInput = moduleApi.renderInput;
export const checkAnswer = moduleApi.checkAnswer;
export const renderAnswer = moduleApi.renderAnswer;
export const renderUserAnswer = moduleApi.renderUserAnswer;
export const renderExplanation = moduleApi.renderExplanation;